import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const vmDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createVm',
        popover: {
          title: 'Create New VM',
          description:
            'Click here to create a new virtual machine. You can configure its resources, operating system, and other settings before deployment.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.refreshVm',
        popover: {
          title: 'Refresh VM Data',
          description:
            'Use this option to refresh the current status and data of the virtual machine. This ensures that you are viewing the most up-to-date information.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.exportVmData',
        popover: {
          title: 'Export VM Data',
          description:
            'Export detailed data about your virtual machines for reporting or analysis purposes. This can include resource usage, status, and configurations.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allAllowedActions',
        popover: {
          title: 'Available VM Actions',
          description:
            'This section lists all the actions you can perform on the virtual machines, such as starting, stopping, or rebooting VMs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.vmMainTable',
        popover: {
          title: 'VM Management Table',
          description:
            'This table provides a comprehensive overview of all virtual machines. You can manage, monitor, and perform actions on your VMs from here.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default vmDriverObj;
